
import "../../../src/main.css";
import React, { useMemo, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  message,
} from "antd/es";
import { wareHouseInward, wareHouseOutwards } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useLocation, useNavigate } from "react-router-dom";

function OffCanvas({ name, ...props }) {
  const [show, setShow] = useState(false);
  const [form] = Form.useForm();
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [selectedToWarehouse, setSelectedToWarehouse] =useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const { warehouses, skus, supplierData } = props;
  const { postInwardData } = wareHouseInward();
  const { setToaster } = useToast();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");
  const {fetchInwardData}=wareHouseInward();
  const {fetchOutwardsData}=wareHouseOutwards();

  const handleClose = () => {
    setShow(false);
    form.resetFields();
		setSelectedWarehouse(null);
		setSelectedToWarehouse(null);
    setSelectedToWarehouse(null);
  }
  const handleShow = () => setShow(true);

  const suppliers = useMemo(() => {
    return supplierData?.map((item) => ({ value: item.id, label: item.code }));
  }, [supplierData]);

  const suppliersData =useMemo(()=>{
    return suppliers?.find(element => element.label === "TRAYA");
  },[suppliers])
  
  const createInward = async (data) => {
    let inwardOutwardArray = [];
    inwardOutwardArray = data.warehousing;
    if (inwardOutwardArray === undefined || inwardOutwardArray.length === 0) {
      message.error(`Please add sku details`);
      return;
    }
    inwardOutwardArray.map((object) => {
      object["batchImporterId"] = null;
      object["companyName"] = null;
      object["shipmentNotes"] = null;
      object["challanNotes"] = null;
      object["toWarehouseId"] = tab==="outwards"?selectedToWarehouse:data.fromWarehouseId;
      object["supplierId"] =tab==="inwards"? data.supplierId:suppliersData?.value;
      object["fromWarehouseId"] = tab==="inwards"?null:data.fromWarehouseId;
      return object;
    });
    const warehouseFunc=tab==="inwards"?fetchInwardData:fetchOutwardsData;
    postInwardData(
      {
        uniqueCode: new Date().getTime(),
        category: "direct_inward_outward",
        inwardOutwardArray: inwardOutwardArray,
      },
      setToaster,
      tab,
      warehouseFunc
    );
    handleClose();
  };

  const handleCancel = () => {
    form.resetFields();
		setSelectedWarehouse(null);
		setSelectedToWarehouse(null);
    setSelectedToWarehouse(null);
  };

  return (
    <>
      <div variant="primary" className="me-2">
        <Button className="btn btn-primary" onClick={handleShow}>
          {tab==="inwards"?"Create Inwards":"Create Outwards"}
        </Button>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        {...props}
        style={{ width: "73%" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h5 className="text-break">{props?.userName}</h5>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <Form form={form} layout="vertical" onFinish={createInward}>
              <div className="warehouse_inward_form d-flex gap-5">
                <Form.Item
                  label={tab==="outwards"?"From Warehouse":"Warehouses"}
                  name="fromWarehouseId"
                  rules={[{ required: true, message: "Please fill this" }]}
                >
                  <Select
                    options={warehouses}
                    style={{ width: 300 }}
                    onChange={(e) => setSelectedWarehouse(e)}
                  />
                </Form.Item>
                {tab === "outwards" ? (
                  <Form.Item
                    label="To Warehouse"
                    name="toWarehouseId"
                    rules={[{ required: true, message: "Please fill this" }]}
                  >
                    <Select
                      options={warehouses}
                      style={{ width: 300 }}
                      onChange={(e) => setSelectedToWarehouse(e)}
                    />
                  </Form.Item>
                ) : (
                  <Form.Item
                    label="Supplier"
                    name="supplierId"
                    rules={[{ required: true, message: "Please fill this" }]}
                  >
                    <Select
                      options={suppliers}
                      style={{ width: 300 }}
                      onChange={(e) => setSelectedSupplier(e)}
                    />
                  </Form.Item>
                )}
              </div>

              {selectedWarehouse !== null && (selectedSupplier !== null || selectedToWarehouse!==null) && (
                <Form.List name="warehousing">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map((field) => (
                        <Space
                          key={field.key}
                          style={{
                            display: "flex",
                            marginBottom: 8,
                          }}
                          align="center"
                        >
                          <Space direction="vertical">
                            <Space>
                              <Form.Item
                                {...field}
                                name={[field.name, "batchCode"]}
                                label="Batch Code"
                              >
                                <Input rows={4} style={{ width: 160 }} />
                              </Form.Item>

                              <Form.Item
                                {...field}
                                name={[field.name, "skuId"]}
                                label="Skus"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please fill this",
                                  },
                                ]}
                              >
                                <Select options={skus} style={{ width: 160 }} />
                              </Form.Item>

                              <Form.Item
                                {...field}
                                label="Quantity"
                                name={[field.name, "quantity"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please fill this",
                                  },
                                  {
                                    pattern: new RegExp(/^[0-9]+$/),
                                    message: "Please enter numbers only",
                                  },
                                ]}
                              >
                                <InputNumber
                                  placeholder="QTY"
                                  min={1}
                                  style={{
                                    width: 160,
                                    margin: 0,
                                  }}
                                />
                              </Form.Item>

                              <Form.Item
                                {...field}
                                label="Supplier Invoice No."
                                name={[field.name, "supplierInvoiceNumber"]}
                              >
                                <Input rows={4} style={{ width: 170 }} />
                              </Form.Item>

                              <Form.Item
                                {...field}
                                label="Notes"
                                name={[field.name, "notes"]}
                              >
                                <Input rows={4} style={{ width: 160 }} />
                              </Form.Item>

                              <Form.Item
                                {...field}
                                label="Challan Number"
                                name={[field.name, "challanNumber"]}
                              >
                                <Input rows={4} style={{ width: 160 }} />
                              </Form.Item>
                            </Space>
                          </Space>

                          <MinusCircleOutlined
                            onClick={() => remove(field.name)}
                          />
                        </Space>
                      ))}
                      <Form.Item>
                        <Row justify="space-between">
                          <Col>
                            <Button
                              type="dashed"
                              onClick={() => add()}
                              icon={<PlusOutlined />}
                            >
                              Add Sku Details
                            </Button>
                          </Col>
                          <Col>
                            <Space>
                              <Button onClick={handleCancel}>Cancel</Button>
                              <Button
                                // loading={loading}
                                type="primary"
                                htmlType="submit"
                              >
                                Create
                              </Button>
                            </Space>
                          </Col>
                        </Row>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              )}
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

function WarehouseInwardCanvas({ warehouses, skus, supplierData }) {
  return (
    <>
      <OffCanvas
        key={6}
        warehouses={warehouses}
        skus={skus}
        supplierData={supplierData}
        placement={"end"}
        name={"Filter"}
      />
    </>
  );
}

export default WarehouseInwardCanvas;
